import { render, staticRenderFns } from "./SupplierReturnDetails.vue?vue&type=template&id=3be2e023&"
import script from "./SupplierReturnDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports